module.exports = __webpack_public_path__ + "static/webDevsWorking-ede52ca33fe495e34ff6d5fae1fa0f73.jpg";